import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import isEmail from 'validator/lib/isEmail';

import HubAvatar from '../HubAvatar';
import SharedDropDownMenu from '../SharedDropDownMenu';
import { renderAvatarUrl } from '../../util/renderHelpers';

class EditUserAccountDialog extends Component {
  static contextTypes = {
    clients: PropTypes.object.isRequired,
  };

  static propTypes = {
    user: PropTypes.object.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: Object.assign({}, props.user), // make sure we are working in a copy of the user object
      valid: false,
    }
  }

  handleValidation(user = this.state.user) {
    let valid = true;
    if (!user.client) {
      valid = false;
    }

    if (!user.email || !isEmail(user.email)) {
      valid = false;
    }

    this.setState({valid});
  }

  /**
   * Notify parent component that the dialog can be closed
   */
  handleClose = () => {
    this.props.onRequestClose();
  }

  /**
   * Send new user data to parent component
   */
  handleSave = () => {
    this.props.onSave(this.state.user);
  }

  handleDatasetChange = (event, index, value) => {
    let {user} = this.state;
    user.client = value;
    this.setState({user});
    this.handleValidation(user);
  }

  handleDisplayNameChange = (event, value) => {
    let {user} = this.state;
    user.displayName = value;
    this.setState({user});
    this.handleValidation(user);
  }

  handleEmailChange = (event, value) => {
    let {user} = this.state;
    user.email = value;
    this.setState({user});
    this.handleValidation(user);
  }

  render() {
    const {user} = this.state;
    const actions = [
      <FlatButton
        label="Cancel"
        onTouchTap={this.handleClose}
      />,
      // somehow make this component catch enters
      <FlatButton
        label="Save"
        primary={true}
        onTouchTap={this.handleSave}
        disabled={!this.state.valid}
      />,
    ];

    const styles = {
      disabledTextField: {
        cursor: 'default',
      },
      centeredText: {
        textAlign:'center',
      },
      datasetDropDown: {
        marginTop: 22,
      },
    }

    const disabledAttrs = {
      disabled: true,
      underlineShow: false,
      inputStyle: styles.disabledTextField,
    }

    // Little trick to add a label for unassigned clients
    let clients = Object.assign({},this.context.clients);
    if (!user.client) {
      clients.none = {name:'Please select a client'};
    }

    return (
      <Dialog
        title="User account"
        actions={actions}
        modal={false}
        open={true}
        onRequestClose={this.handleClose}
      >
        <div style={styles.centeredText}>
          <HubAvatar src={renderAvatarUrl(user.photoUrl)} size={120}/>
          <br/>
          {user.uid && <TextField floatingLabelText="UID" value={user.uid||'n\\a'} {...disabledAttrs} />}
          <br/>
          <TextField floatingLabelText="Display name" onChange={this.handleDisplayNameChange} defaultValue={user.displayName} />
          <br/>
          <TextField floatingLabelText="Email" onChange={this.handleEmailChange} defaultValue={user.email} />
          <br />
          <InputContainer>
            <InputLabel>Client</InputLabel>
            <SharedDropDownMenu value={user.client || 'none'} onChange={this.handleDatasetChange} datasets={clients} style={styles.datasetDropDown} />
          </InputContainer>
          {/*<Divider/>
          <br />
          <p>These buttons are here in case you accidentally clicked 'no' for sending the welcome mail</p>
          <RaisedButton label="Send welcome mail" />
          <RaisedButton label="Send confirmation mail" />
          <br />*/}
          
        </div>
      </Dialog>
    )
  }
}

export default EditUserAccountDialog;


const InputLabel = ({children, ...rest}) => {
  const labelStyle ={
    position: 'absolute',
    lineHeight: '22px',
    top: '38px',
    zIndex: 1,
    transform: 'scale(0.75) translate(0px, -28px)',
    transformOrigin: 'left top 0px',
    pointerEvents: 'none',
    userSelect: 'none',
    color: 'rgba(0, 0, 0, 0.3)',
  }
  return (
    <label style={labelStyle} {...rest}>{children}</label>
  )
}

InputLabel.propTypes = {
  children: PropTypes.any,
}

const InputContainer = ({ children, ...rest }) => {
  let style = {
    position: 'relative',
    fontSize: '16px',
    lineHeight: '24px',
    width: '256px',
    height: '72px',
    display: 'inline-block',
    textAlign: 'left',
  };

  return (
    <div
      {...rest}
      style={style}
    >
      {children}
    </div>
  )
}

InputContainer.propTypes = {
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/EditUserAccountDialog/index.jsx